<template>
  <div id="app"   :class="{hidden_body:isHidden}">
    <router-view></router-view>
  </div>
</template>

<script>
//TODO 按需加载
export default {
  name: 'app',
  computed: {
    isHidden(){
      return this.$store.state.bodyOverflow
    } 
  }
}
</script>
<style>
#app {
  height: 100%;
}

.hidden_body {
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// App.vue?7b823a94